import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { HtmlUtils } from '@core/helpers/HtmlUtils';

@Component({
    selector: 'm4u-status-column',
    templateUrl: './status-column.component.html',
    styleUrls: ['./status-column.component.scss']
})
export class StatusColumnComponent {

    @Input() Icon: string;
    @Input() IconUrl: string;
    @Input() Text: string;
    @Input() Color: string;
    @Input() Position: 'start' | 'center' | 'end' = 'start';
    //@Input() IsFullWidth: boolean;

    constructor(private elRef: ElementRef) { }

    GetClass() {
        return `status-column-position-${this.Position}`;
    }

    getHtmlContent() {
        return this.elRef.nativeElement;
    }

    //GetBackgroundColor() {
    //    return this.Color && `rgba(${HtmlUtils.HexToRgbColorString(this.Color)}, 0.1)`;
    //}

}
